import { Icon, IconDefinitions, InfoDetail, StatusBadge } from "../../../../components";
import { GaugeConfig, PeakSignalModel } from "../../../../data/entities";
import { getGaugeLevel, rawToPercent } from "../../helper/helpers";
import { SIGNAL_LABELS, formatNumber, formatTime } from "./peakSignalFormat";

export const SeverityBadge = ({ value, config }: { value: number; config: GaugeConfig | null }) => {
  if (!config) return null;
  const level = getGaugeLevel(value, config);
  const percent = rawToPercent(value, config);
  return (
    <span className="d-inline-flex align-items-center gap-2">
      {level === "critical" ? (
        <StatusBadge variant="red" label="Alert" size="sm" />
      ) : level === "caution" ? (
        <StatusBadge variant="amber" label="Warning" size="sm" />
      ) : (
        <StatusBadge variant="gray" label="Recorded" size="sm" />
      )}
      {percent != null && <span>{Math.round(percent)}% of threshold</span>}
    </span>
  );
};

export const buildSignalDetails = (
  signal: PeakSignalModel,
  config: GaugeConfig | null,
  includePositions: boolean = true
): InfoDetail[] => {
  const details: InfoDetail[] = [
    {
      label: "Signal",
      value: `${signal.signalType} — ${SIGNAL_LABELS[signal.signalType]}`,
      icon: <Icon iconName={IconDefinitions.list} />,
    },
    {
      label: "Peak Value",
      value: formatNumber(signal.peakValue),
      icon: <Icon iconName={IconDefinitions.circleInfo} />,
    },
  ];

  if (config) {
    details.push({
      label: "Severity",
      value: <SeverityBadge value={signal.peakValue} config={config} />,
      icon: <Icon iconName={IconDefinitions.chartLine} />,
    });
  }

  if (signal.startTime) {
    details.push({
      label: "Start",
      value: formatTime(signal.startTime),
      icon: <Icon iconName={IconDefinitions.clock} />,
    });
  }

  if (includePositions && signal.startPosition != null) {
    details.push({
      label: "Position",
      value:
        signal.endPosition != null
          ? `${formatNumber(signal.startPosition)} – ${formatNumber(signal.endPosition)}`
          : formatNumber(signal.startPosition),
      icon: <Icon iconName={IconDefinitions.list} />,
    });
  }

  return details;
};
